import { Box, CardContent, Grid } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import BedStatusBottom from "./BedStatusBottom";
import BedStatusInputField from "./BedStatusInputField";

import { RootState } from "../../../redux/store";
import { userRoles } from "../../../constants/user";

const BedStatusForm = () => {
  const [isDisabled, setIsDisabled] = useState(false);

  const { values, setFieldValue, setValues } = useFormikContext<FormikValues>();

  const { bedStatus } = useSelector((state: RootState) => state);
  const { role } = useSelector(
    (state: RootState) => state.auth.profileData.user
  );

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (+value < 0) {
      return;
    }
    setFieldValue(name, value);
    if (name === "availableOnWard") {
      setFieldValue("totalWard", +value + +values.occupiedOnWard);
    }
    if (name === "occupiedOnWard") {
      setFieldValue("totalWard", +value + +values.availableOnWard);
    }
    if (name === "availableOnICU") {
      setFieldValue("totalIcu", +value + +values.occupiedOnICU);
    }
    if (name === "occupiedOnICU") {
      setFieldValue("totalIcu", +value + +values.availableOnICU);
    }
  };

  useEffect(() => {
    setValues({
      availableOnWard: +bedStatus.WARD.available,
      occupiedOnWard: +bedStatus.WARD.occupied,
      totalWard: +bedStatus.WARD.total,
      availableOnICU: +bedStatus.ICU.available,
      occupiedOnICU: +bedStatus.ICU.occupied,
      totalIcu: +bedStatus.ICU.total,
    });

    setIsDisabled(
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role) ? false : true
    );
  }, [bedStatus, role, setValues]);

  return (
    <CardContent className="bed-availability-card">
      <Box sx={{ display: "flex", flexWrap: "wrap", margin: "0 -15px 0" }}>
        <Box
          sx={{
            width: "50%",
            padding: "0 15px 0",
            "@media (max-width: 991px)": {
              width: "100%",
            },
          }}
        >
          <BedStatusInputField
            name="availableOnWard"
            placeholder="Available Beds in ward"
            label=" Beds available in ward"
            min="0"
            disabled={isDisabled}
            onChange={inputHandler}
          />
          <BedStatusInputField
            name="occupiedOnWard"
            placeholder="Occupied Beds in ward"
            label=" Beds occupied in ward"
            min="0"
            disabled={isDisabled}
            onChange={inputHandler}
          />

          <BedStatusInputField
            name="totalWard"
            placeholder="Total Bed in ward"
            label="Total Bed in ward"
            min="0"
            disabled
            onChange={inputHandler}
          />
        </Box>
        <Box
          sx={{
            width: "50%",
            padding: "0 15px 0",
            "@media (max-width: 991px)": {
              width: "100%",
            },
          }}
        >
          <BedStatusInputField
            name="availableOnICU"
            placeholder="Available Beds in ICU"
            label=" Beds available in ICU"
            min="0"
            disabled={isDisabled}
            onChange={inputHandler}
          />
          <BedStatusInputField
            name="occupiedOnICU"
            placeholder="Occupied Beds in ICU"
            label=" Beds occupied in ICU"
            min="0"
            disabled={isDisabled}
            onChange={inputHandler}
          />

          <BedStatusInputField
            name="totalIcu"
            placeholder="Total Beds in ICU"
            label="Total Beds in ICU"
            min="0"
            disabled
            onChange={inputHandler}
          />
        </Box>
      </Box>
      {!isDisabled && <BedStatusBottom />}
    </CardContent>
  );
};

export default BedStatusForm;
